/**
 * Block Frontend Scripts
 * 
 * Scripts that run on both frontend and block editor
 */

// Import block styles
import '../../scss/blocks/blocks.scss';

// Shared block utilities
export const TakumoBlocks = {
    /**
     * Initialize accordion functionality
     */
    initAccordions: function() {
        const accordions = document.querySelectorAll('.takumo-accordion');
        
        accordions.forEach(accordion => {
            const triggers = accordion.querySelectorAll('.accordion-trigger');
            
            triggers.forEach(trigger => {
                trigger.addEventListener('click', function(e) {
                    e.preventDefault();
                    
                    const content = this.nextElementSibling;
                    const isOpen = this.getAttribute('aria-expanded') === 'true';
                    
                    // Close all other accordions in this group
                    triggers.forEach(otherTrigger => {
                        if (otherTrigger !== this) {
                            otherTrigger.setAttribute('aria-expanded', 'false');
                            otherTrigger.nextElementSibling.style.maxHeight = null;
                        }
                    });
                    
                    // Toggle current accordion
                    if (isOpen) {
                        this.setAttribute('aria-expanded', 'false');
                        content.style.maxHeight = null;
                    } else {
                        this.setAttribute('aria-expanded', 'true');
                        content.style.maxHeight = content.scrollHeight + 'px';
                    }
                });
            });
        });
    },
    
    /**
     * Initialize form handling
     */
    initForms: function() {
        const forms = document.querySelectorAll('.takumo-contact-form');
        
        forms.forEach(form => {
            form.addEventListener('submit', function(e) {
                e.preventDefault();
                
                const formData = new FormData(this);
                const submitButton = this.querySelector('button[type="submit"]');
                const originalText = submitButton.textContent;
                
                // Show loading state
                submitButton.textContent = 'Sending...';
                submitButton.disabled = true;
                
                // Here you would typically send the form data via AJAX
                // For now, we'll just simulate a successful submission
                setTimeout(() => {
                    submitButton.textContent = 'Message Sent!';
                    this.reset();
                    
                    setTimeout(() => {
                        submitButton.textContent = originalText;
                        submitButton.disabled = false;
                    }, 2000);
                }, 1000);
            });
        });
    },
    
    /**
     * Initialize all block functionality
     */
    init: function() {
        this.initAccordions();
        this.initForms();
    }
};

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
    TakumoBlocks.init();
});

// Make available globally for other scripts
window.TakumoBlocks = TakumoBlocks;